module.exports = __webpack_public_path__ + "static/media/Logo.11008d2b.svg";